<template>
    <div>
        <div class="card">
            <div class="row justify-content-end">
                <div class="col-sm-3 d-flex position-absolute justify-content-end gap-3 mt-3 me-2 pt-1">
                    <!-- <button @click.prevent="onAddMeterClick()" class="btn btn-sm btn-primary rounded-2"> -->
                    <button v-if="showEditValuesBtn" class="btn btn-sm btn-primary rounded-2"
                        @click="showModal({ component: 'lakeviewParameters' })">
                        Edit Values
                    </button>
                    <div></div>
                </div>
            </div>
            <datatable tableId="parametersTable" :columns="columns" :data="parameters" :ignoreCache="true"
                :showLoading="parameters === null" />
        </div>
    </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import Datatable from '../../../components/Datatable.vue';
import { formatLakeviewParameterValueColumn } from "../../../components/modals/LakeviewParameters.vue";

export default {
    components: { Datatable },
    data() {
        return {
            columns: [
                { data: "name" },
                { data: "description" },
                { data: "type" },
                { data: "required" },
                { data: "read_only", title: "read only" },
                {
                    data: "value",
                    render: (data, _type, row) => formatLakeviewParameterValueColumn(data, row),
                },
            ],
            showEditValuesBtn: false
        };
    },
    mounted() {
        if (this.$store.state.sandbox.prodV2Sandboxes.map(sandbox => { return sandbox.name })
            .includes(this.$store.state.sandbox.currentSandbox)) {
                // allow access for aqfer_admin in prod v2 sandbox jobs
                this.showEditValuesBtn = this.$store.getters.userRoles.isAccessByRole([1])
        } else if (this.$store.state.sandbox.devSandboxes.map(sandbox => { return sandbox.name })
            .includes(this.$store.state.sandbox.currentSandbox)) {
                // allow access for aqfer_admin, aqfer_manager, client_admin in dev sandbox jobs
                this.showEditValuesBtn = this.$store.getters.userRoles.isAccessByRole([1, 1.5, 3])
        } else { 
            // disallow access for all roles in prod sandbox jobs
            this.showEditValuesBtn = true
        }
        this.$emit('showOverrideEdit', false);
        this.$emit('setOverrideEditMode', false);
    },
    emits: ['showOverrideEdit', 'setOverrideEditMode'],
    computed: {
        ...mapState({
            parameters: (state) => state.amdp.lakeviewParameters,
        }),
    },
    methods: {
        ...mapActions({
            showModal: "showModal",
        }),
    }
};
</script>
<style></style>
